import axios from "axios";

export const getGroups = async (body) => {
  try {
    const res = await axios.post("/api/v1/groupManagement/getGroups", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getGroup = async (body) => {
  try {
    const res = await axios.post("/api/v1/groupManagement/getGroup", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const createGroup = async (body) => {
  try {
    const res = await axios.post("/api/v1/groupManagement/createGroup", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const updateGroup = async (body) => {
  try {
    const res = await axios.post("/api/v1/groupManagement/updateGroup", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const deleteGroup = async (body) => {
  try {
    const res = await axios.post("/api/v1/groupManagement/deleteGroup", body);
    if (res?.status === 200) return res.data.result;
    throw new Error(res);
  } catch (error) {
    console.error(error);
    return null;
  }
};
